import { get } from 'lodash/fp';

function makePublicTokenSelector(tokenName) {
  return get(['publicTokens', 'entities', tokenName]);
}

export default makePublicTokenSelector;
